import type { ReactNode } from 'react';

export const symbol_eyebrow: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M609-407q-38 0-83 7t-97.5 21.5q-52.5 14.5-114 37T181-288q-10.03 4.44-20.51 6.22Q150-280 136-280q-48.33 0-82.17-33.54Q20-347.08 20-395v-109q0-41.18 26.16-73.26Q72.31-609.34 113-617q78-17 146.06-28.59 68.07-11.6 128-19.5Q447-673 502-676.5t107-3.5q134 0 222 98.5T940-310q1 8-4 14.5T922-285q-9 3-19 1.5t-18-7.5q-70.14-54.21-143.57-85.1Q668-407 609-407Zm0-60q65 0 125.5 21.5T870-375q-23-109-95.5-177T608-620q-112 0-232 15.5T125-558q-20 5-32.5 19.5T80-504v109q0 30.31 24.5 46.16Q129-333 158-344q85-34 151.5-57.5t120-38q53.5-14.5 97-21T609-467Zm-134-37Z"
		/>
	</svg>
);
